import React from "react";
import { toast } from "sonner";
import { CSLB_URL, LICENSE_NUMBER } from "../lib/content";

export const LicenseLink = ({ t, children, className, testId }) => {
  const onClick = () => {
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(LICENSE_NUMBER).catch(() => {});
    }
    toast.success(t.footer.licenseCopied, { description: t.footer.licenseCopiedDesc });
  };

  return (
    <a
      href={CSLB_URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
      title={t.footer.licenseVerify}
      aria-label={t.footer.licenseVerify}
      data-testid={testId}
      className={className}
    >
      {children}
    </a>
  );
};
